import React from 'react';
import PropTypes from 'prop-types';
import DocumentRow from "./DocumentRow";

const DocumentsSection = ({
                              documents,
                              header,
                              className = "proposal-document-header",
                              subheader,
                              onDelete,
                              onUpdate,
                              disabled,
                              emptyMessage = 'No Slides Yet',
                              ...props
                          }) => {

    return (
        <React.Fragment>
            <div className={className}>
                <h3>
                    {header}
                </h3>
                {subheader && (
                    <p>
                        {subheader}
                    </p>
                )}

            </div>

            {documents?.length ? documents.map(doc => (
                <DocumentRow
                    key={`doc-${doc.id}`}
                    hideDetails={props.hideDetails}
                    document={doc}
                    onUpdate={TB.isDefined(onUpdate) ? () => onUpdate(doc) : undefined}
                    onDelete={TB.isDefined(onDelete) ? () => onDelete(doc) : undefined}
                    disabled={disabled}
                />
            )) : (
                <div className='empty-talent-project-documents-container'>
                    {emptyMessage}
                </div>
            )}

            {props.children}
        </React.Fragment>
    )
};

DocumentsSection.propTypes = {
    header: PropTypes.any,
    subheader: PropTypes.any,
    documents: PropTypes.array,
    onDelete: PropTypes.any,
    onUpdate: PropTypes.any,
    disabled: PropTypes.any,
    emptyMessage: PropTypes.any
};

export default DocumentsSection;
